// Angular
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { AppCleanup } from '../../../shared/models';
import { OutputConfigViewModel } from '../models/output-config-view.model';

@Injectable({
	providedIn: 'root',
})
export class OutputConfigService extends AppCleanup {
	private outputConfigUrl;
	domain: string = window.location.hostname;

	constructor(private http: HttpClient) {
		super();
		this.outputConfigUrl = `${this.apiUrl}api/outputadapterconfig`;
	}

	getOutputConfigs() {
		return this.http.get<OutputConfigViewModel[]>(this.outputConfigUrl);
	}

	getOutputConfig(outputConfigId: number) {
		return this.http.get<OutputConfigViewModel>(`${this.outputConfigUrl}/${outputConfigId}`);
	}

	createOutputConfig(outputConfigId: OutputConfigViewModel) {
		return this.http.post<OutputConfigViewModel>(`${this.outputConfigUrl}`, outputConfigId);
	}

	updateOutputConfig(outputConfigId: OutputConfigViewModel) {
		return this.http.put<OutputConfigViewModel>(`${this.outputConfigUrl}/${outputConfigId.id}`, outputConfigId);
	}

	deleteOutputConfig(outputConfigId: number) {
		return this.http.delete<OutputConfigViewModel>(`${this.outputConfigUrl}/${outputConfigId}`);
	}

	// importUnitConfig(legacyUnitConfigs: LegacyUnitConfigViewModel[]) {
	//     return this.http.post<LegacyUnitConfigViewModel[]>(`${this.outputConfigUrl}/legacy`, legacyUnitConfigs);
	// }

	// getUnitConfigTemplates() {
	//     return this.http.get<any>(`${this.outputConfigUrl}/templates`);
	// }

	// validateExpression(valdationObject: ValidationObject): Observable<ValidationResponse> {
	//     return this.http.post<ValidationResponse>(`https://${this.domain}:5003/api/unitconfigurations/validate`, valdationObject);
	// }
}

export class ValidationObject {
	expression: string;
	channelNames: string[];
}

export class ValidationResponse {
	isValid: boolean;
	errorMessage: string;
}
